import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { Form, InputRef } from 'antd';
import Modal from 'components/Modal';
import InputCateGoryName from './InputCateGoryName';
import styled from 'styled-components';
import { IProductCategoryItem } from 'services/shop/types/product';
import { IUpdateCateBodyForProduct } from 'features/settingService/services/types/api';
import {
  createCategoryForProduct,
  updateNameCategoryForProduct,
} from 'features/settingService/services/apis';
import shopActions from 'services/shop/actions';
import { useAppDispatch } from 'store/hooks';
import toast from 'utils/toast';
import { CATEGORY_TYPE } from 'features/settingService/services/constants';
import shopSelectors from 'services/shop/selectors';

interface Props {}

export interface IModalAddOrUpdateCategoryRef {
  open: (data?: IProductCategoryItem) => void;
}

type FormType = {
  id: string;
  categoryName: string;
};

const initialValues: FormType = {
  id: '',
  categoryName: '',
};

const AddOrUpdateCategoryModal = forwardRef<IModalAddOrUpdateCategoryRef, Props>((_, ref) => {
  const inputRef = useRef<InputRef>(null);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm<FormType>();
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState<IProductCategoryItem | null>(null);
  const [loading, setLoading] = useState(false);
  

  const handleClose = () => {
    setVisible(false);
    setData(null);
    form.resetFields();
  };

  const handleSubmit = () => {
    form.submit();
  };

  const onFinish = async (values: FormType) => {
    try {
      setLoading(true);
      const body: IUpdateCateBodyForProduct = {
        categoryId: data?.id ?? '',
        cateName: values.categoryName,
        cateType: CATEGORY_TYPE.PRODUCT,
      };
      if (data?.id) {
        await updateNameCategoryForProduct(body);
      } else {
        await createCategoryForProduct(body);
      }
      dispatch(shopActions.get.productCategories.fetch());
      handleClose();
      toast.success('Create category successfully');
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    open: (data?: IProductCategoryItem) => {
      setVisible(true);
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
      if (data) {
        setData(data);
        form.setFieldValue('categoryName', data?.categoryName || '');
      }
    },
  }));

  return (
    <Modal
      v2
      noneBodyStyle
      width={900}
      visible={visible}
      onClose={handleClose}
      onSubmit={handleSubmit}
      modalTitle={data ? 'Edit Category' : 'Add Category'}
      okTitle='OK'
      disableOk={loading}
    >
      <Wrapper>
        <Form form={form} onFinish={onFinish} initialValues={initialValues} layout='vertical'>
          <Form.Item
            name='categoryName'
            rules={[{ required: true, message: 'Category name is required' }]}
          >
            <InputCateGoryName ref={inputRef} />
          </Form.Item>
        </Form>
      </Wrapper>
    </Modal>
  );
});

AddOrUpdateCategoryModal.displayName = 'AddOrUpdateCategoryModal';

export default AddOrUpdateCategoryModal;

const Wrapper = styled.div`
  padding: 16px;
  padding-bottom: 40px;
`;
